const GET_FLEET_ITEM_RETURN_TO_REQUESTOR = 'GET_FLEET_ITEM_RETURN_TO_REQUESTOR'
const SET_FLEET_ITEM_RETURN_TO_REQUESTOR = 'SET_FLEET_ITEM_RETURN_TO_REQUESTOR'

const GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR = 'GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR'
const SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR = 'SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR'

const GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR = 'GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR'

export {
    GET_FLEET_ITEM_RETURN_TO_REQUESTOR,
    SET_FLEET_ITEM_RETURN_TO_REQUESTOR,
    GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
    SET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR,
    GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR
}
